import { Select } from "./Select";
import { AutocompleteField } from "./AutocompleteField";
import { Switch } from "./Switch";
import { Search } from "./Search";
import { Text } from "./Text";
import { DateRange } from "./DateRange";

export const Inputs = {
  Text,
  Select,
  Switch,
  Search,
  AutocompleteField,
  DateRange,
};
